import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ConverterService,
  OccEndpointsService,
  OccProductAdapter,
  OccRequestsOptimizerService
} from '@spartacus/core'
import { Observable } from 'rxjs'
import { EBStructuredProductData } from '../../../cms/interfaces/eb-page.interface'
import { EbProductSearchPage } from '../../interfaces/eb-product.interface'

@Injectable()
export class EbProductAdapter extends OccProductAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected requestsOptimizer: OccRequestsOptimizerService
  ) {
    super(http, occEndpoints, converter, requestsOptimizer)
  }

  fetchVariants(
    productCode: string,
    pageSize: number,
    currentPage: number,
    sorting: string,
    unitOfLength: string,
    query = '',
    freeTextSearch = ''
  ): Observable<EbProductSearchPage> {
    return this.http.get(
      this.occEndpoints.buildUrl('variants', {
        urlParams: {
          freeTextSearch,
          productCode,
          sorting,
          query
        },
        queryParams: {
          pageSize,
          currentPage,
          unitOfLength
        }
      })
    )
  }

  fetchStructuredProductData(productCode: string): Observable<EBStructuredProductData> {
    return this.http.get(
      this.occEndpoints.buildUrl('structuredProductData', {
        urlParams: {
          productCode
        }
      })
    ) as Observable<EBStructuredProductData>
  }

  decryptVariantCode(encrypted) {
    return this.http.get(
      this.occEndpoints.buildUrl('decryptVariantCode', {
        urlParams: {
          encrypted
        }
      })
    ) as Observable<string>
  }

  getDownloadDocument(mediaCode: string) {
    return this.http.get(
      this.occEndpoints.buildUrl('downloadDocument', { urlParams: { mediaCode } }),
      {
        responseType: 'blob',
        headers: new HttpHeaders({
          Accept: 'application/pdf'
        })
      }
    )
  }
}
